import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-column-chart',
  templateUrl: './simple-column-chart.component.html',
  styleUrls: ['./simple-column-chart.component.scss']
})
export class SimpleColumnChartComponent implements OnInit {
  dataSource: any;
  constructor() {
    // Preparing the chart data
    this.dataSource = {
      chart: {
        xAxisName: '',
        yAxisName: '',
        numberSuffix: 'K',
        theme: 'fusion',
        placevaluesinside: '0',
        showvalues: '1',
        valuefontcolor: '#000000',
        paletteColors: '#428DFF',
        bgColor: '#fdfdfd',
        maxColWidth: '6'
      },
      data: [
        {
          label: 'Visited Brand Store',
          value: '49.344'
        },
        {
          label: 'Saw Competitor Ads',
          value: '37.345'
        },
        {
          label: 'Visited Mobile Store',
          value: '34.344'
        }
      ]
    };
  }

  ngOnInit() {
  }

}
